import { render, staticRenderFns } from "./FichaEditaProducto.vue?vue&type=template&id=16010604"
import script from "./FichaEditaProducto.vue?vue&type=script&lang=js"
export * from "./FichaEditaProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports